import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteField from '../../../components/molecules/AutoCompleteField';
import { AutoCompleteSizes } from '../../../components/molecules/AdvancedAutoComplete/consts';
import { AutoCompleteOptionType } from '../../../components/molecules/autocompleteTypes';

const FilterAutoComplete = ({
    options,
    value,
    onChange,
    label,
    clearable = false,
    loading = false,
    onRemove,
    isMulti = false,
    openUpward = false,
    containerClass,
}) => (
    <AutoCompleteField
        options={options}
        value={isMulti ? value : value ? [value] : []}
        onChange={onChange}
        label={label}
        advanced
        isMulti={isMulti}
        containerClass={containerClass}
        size={AutoCompleteSizes.Small}
        clearable={clearable}
        loading={loading}
        ignoreScrollEvents
        onRemove={onRemove}
        removable={!!onRemove}
        openUpward={openUpward}
    />
);

FilterAutoComplete.propTypes = {
    options: PropTypes.arrayOf(AutoCompleteOptionType).isRequired,
    value: AutoCompleteOptionType,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    clearable: PropTypes.bool,
    loading: PropTypes.bool,
    onRemove: PropTypes.func,
    isMulti: PropTypes.bool,
    openUpward: PropTypes.bool,
    containerClass: PropTypes.string,
};

export default FilterAutoComplete;
